import { useEffect, useState } from 'react';
import { Analysis, IGetEffectReportDetailsResp, StructuredAnalysisData } from '../services/reports';

const typeMapping: { [key: string]: (data: Analysis, state: StructuredAnalysisData) => void } = {
  'EFFECT INPUT': (data, state) => (state.results.input = data),
  'EFFECT PROCESSES': (data, state) => (state.results.processes = data),
  'EFFECT EMERGENT STATES': (data, state) => (state.results.emergentStates = data),
  'EFFECT OUTPUT': (data, state) => (state.results.output = data),
  'EFFECT FIVE CHALLENGES': (data, state) => (state.insights.fiveChallenges = data),
  'EFFECT CLARITY': (data, state) => (state.insights.clarity = data),
  'EFFECT QUALITY': (data, state) => (state.insights.quality = data),
  'EFFECT RELATIONSHIP': (data, state) => (state.insights.relationship = data),
  'EFFECT BEHAVING': (data, state) => (state.insights.behaving = data),
  'EFFECT LEARNING': (data, state) => (state.insights.learning = data),
  'EFFECT EXTERNAL': (data, state) => (state.externalResults.external = data),
  'EFFECT TOP TOPICS': (data, state) => (state.topAndBottom.top = data),
  'EFFECT BOTTOM TOPICS': (data, state) => (state.topAndBottom.bottom = data),
  'EFFECT MOST IMPROVED': (data, state) => (state.topAndBottom.improved = data),
};

export const useReportMapping = (effectData: IGetEffectReportDetailsResp | null) => {
  const [structuredData, setStructuredData] = useState<StructuredAnalysisData>({
    results: {},
    insights: {},
    externalResults: {},
    topAndBottom: {},
  });

  useEffect(() => {
    if (effectData) {
      const configuredData = effectData.analysis.reduce(
        (acc: StructuredAnalysisData, item: Analysis) => {
          const handler = typeMapping[item.type];
          if (handler) {
            handler(item, acc);
          }
          return acc;
        },
        { results: {}, insights: {}, externalResults: {}, topAndBottom: {} }
      );

      // TODO: handle unreceived somehow else

      if (!configuredData.topAndBottom.improved) {
        configuredData.topAndBottom.improved = {
          type: 'EFFECT MOST IMPROVED',
          included_topics: [],
          description: '',
        };
      }

      setStructuredData(configuredData);
    }
  }, [effectData]);

  return structuredData;
};
